import { useId, useEffect, useState, ReactNode } from "react";
import './input-base.css'
import './input-select.css'
import { clsx } from "../../functions.ts";
import { InputValidity } from "./input-base.tsx";
import { PropertiesAutoFillState } from "../../state/types.ts";

export default function SelectionInput (props: {
	label: string,
	value: string | number | undefined,
  auto_filled?: PropertiesAutoFillState,
  infoButton?: ReactNode,
  hint?: string,
  hint_static?: string,
  options: Array<{label: string, value: string | number}>,
  onChange: (value: string) => void
  onBlur?: () => void,
  validate?: (value: string) => Promise<boolean>,
  onValidate?: (valid: boolean) => void,
}){
  const [nonValidValue, setNonValidValue] = useState<undefined | string>(undefined);
  const id = useId();

  useEffect(()=>{
    if(props.options && props.options.length === 1 && String(props.value) !== String(props.options[0].value)){
      props.onChange(props.options[0].value.toString());
    }
  },[props.options]);

  const auto_filled_hint = props.auto_filled !== undefined ? " (geschätzt)" : "";
  const validity = nonValidValue !== undefined ? InputValidity.Invalid : InputValidity.Valid;

  return <div className={"select-input input"}>
        <div className={"select-input__label input__label"}>
          {props.infoButton}
          <label htmlFor={id} id={id+"-label"}>{props.label + auto_filled_hint}</label>
        </div>
        <div className={clsx("base_input", validity == InputValidity.Invalid && "base_input--invalid")}>
          <select 
            className={"select-input__input input__input"}
            aria-labelledby={id+"-label"}
            aria-describedby={id+"-hint"}
            aria-invalid={validity == InputValidity.Invalid}
            tabIndex={0}
            id={id} 
            value={nonValidValue !== undefined ? nonValidValue : (props.value ?? "")} 
            onBlur={()=>{
            if(props.onBlur == undefined ){return;}
            props.onBlur();
          }} onChange={async (e)=>{
              const value = e.target.value;
              if(props.validate !== undefined && !(await props.validate(value))){
                setNonValidValue(value);
                props.onChange(undefined);
                if(props.onValidate){
                  props.onValidate(false);
                }
                return;
              }
              if(props.onValidate){
                props.onValidate(true);
              }
              setNonValidValue(undefined);
              props.onChange(value == "" ? undefined : value);
            }}>
            {props.options.map((option)=><option key={option.label} value={option.value}>{option.label}</option>)}
          </select>
          {props.hint && validity == InputValidity.Invalid && <div role="alert" id={id+"-hint"} className="input__hint">{props.hint}</div>}
          {props.hint_static && <div role="alert" id={id+"-hint"} className="input__hint input__hint--static">{props.hint_static}</div>}
        </div>
    </div>
}
